'use es6';

import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link as FoundationsLink } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const langKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.needMoreAdvancedFeatures.${key}`;
const Link = ({
  onClick,
  linkMessage = '',
  external = false
}) => /*#__PURE__*/_jsx(FoundationsLink, {
  onClick: onClick,
  external: external,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey(linkMessage)
  })
});
const NeedMoreAdvancedFeatures = ({
  hasPermissions = false,
  openFormFn = () => {}
}) => {
  if (!hasPermissions) return null;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: langKey('message'),
    "data-test-id": "opt-out-message",
    options: {
      visitFullEditor: /*#__PURE__*/_jsx(Link, {
        onClick: openFormFn,
        linkMessage: "visitFullEditor",
        external: true
      })
    }
  });
};
export default NeedMoreAdvancedFeatures;